export function isTruthy(field: unknown): boolean {
  return field === "true" || field === true;
}
